export default __webpack_public_path__ + "static/media/instawhite.46db2994.svg";